import { Row, Col } from 'reactstrap';
import { useEffect, useState } from 'react';
import TopCards from '../../components/Institute Dashboard/TopCards';
import SalesOverview from '../../components/Institute Dashboard/SalesOverview';
import VisitSeparation from '../../components/Institute Dashboard/VisitSeparation';
import axiosInstance from '../../helpers/axios';
import search from "../../assets/images/search.png";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { Autocomplete, TextField, InputAdornment } from "@mui/material";
import WebsiteVisit from '../../components/Institute Dashboard/WebsiteVisit';
import Twitter from '../../components/Institute Dashboard/Twitter';
import Facebook from '../../components/Institute Dashboard/Facebook';
import Gmail from '../../components/Institute Dashboard/Gmail';
import { useSelector } from "react-redux";
import { useCurrentUser } from '../../hooks/useCurrentUser';

const Demographical = () => {
  const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);
   const [id,setId]=useState(null)
  const [isInstituteSelected, setIsInstituteSelected] = useState(false);
   const [instiName,setInstituteName]=useState([]);
   const [showDropdown, setShowDropdown] = useState(false);
   const [searchText, setSearchText] = useState("");
   const[instituteDetails,setinstituteDetails]=useState([]);
   const [searchClicked,setSearchClicked] = useState(false)
   const [totalSales, setTotalSales] = useState(0);
   const [thisMonthSales, setThisMonthSales] = useState(0);
   const [totalAppCount, setTotalAppCount] = useState(0);
   const [thisMonthCount, setThisMonthCount] = useState(0);
   const [thisWeekSales, setThisWeekSales] = useState(0);
   const[ months,setMonths] =useState([])
   const[disbursementAmounts,setDisbursementAmounts]=useState([])
   const[actualDisbursementAmounts,setActualDisbursementAmounts]=useState([])
   const[ovdBackets,setOvdBackets]=useState([])
   const[ovdPercentage,setOvdPercentage]=useState([])
   const[ovdCount,setOvdCount]=useState([])
   const[ovdPos,setOvdPOS]=useState([])
   const [isLoading, setIsLoading] = useState(false); 
  const [topCardsLoading, setTopCardsLoading] = useState(false);
   const [applmonth, setApplMonth] = useState([]); 
   const [applDisb, setApplDisb] = useState([]); 
   const [applCount, setApplCount] = useState([]); 
   const [applRate, setApplRate] = useState([]); 
   const [brandName, setBrandName] = useState('');
   const [instituteName, setInistuteName] = useState('')
  const [instituteList,setInstituteList]=useState([])
  const [startingPhrase,setStarterPhrase]=useState("Type Institute Name") 
  const [internalValue, setInternalValue] = useState("");

  useEffect(() => {
    if (productTypeSelected !== "2") {
      setId(null);
      setInternalValue("");
      setIsInstituteSelected(false);
      return;
    }

    const setDefaultPersonalLoan = async () => {
      try {
        const response = await axiosInstance.get(`/institute/info/name?name=pers`, {
          headers: {
          },
        });

        const personalLoan = response?.data?.data?.find(
          (item) => item?.brandName === "Personal Loan"
        );

        if (personalLoan?.id) {
          setId(personalLoan.id);
          setInternalValue("Personal Loan");
          setIsInstituteSelected(true);

          instituteInfo(personalLoan.id);
          instiDisbursement(personalLoan.id);
          instiBackets(personalLoan.id);
          applicationVisist(personalLoan.id);
        }
      } catch (error) {
        console.error("Error setting default Personal Loan:", error);
      }
    };

    setDefaultPersonalLoan();
  }, [productTypeSelected]);

  const [errors, setErrors] = useState({})

   
  const decode = useCurrentUser();
  const user = null;


  

const getInstituteInfo = async (text) => {
  const trimmedText = text.trim();

  // Clear the list if input is empty or too short
  if (!trimmedText || trimmedText.length < 4) {
    setInstituteList([]);
    setStarterPhrase("Type Institute Name");
    return;
  }

  // API call to fetch institutes based on the input
  const instituteInfoUrl = `/institute/info/name?name=${trimmedText}`;
  try {
    const response = await axiosInstance.get(instituteInfoUrl, {
      headers: {
      },
    });

    const institutes = response?.data?.data || [];
    if (institutes.length === 0) {
      setInstituteList([]);
      setStarterPhrase("No institute found");
    } else {
      const formattedData = institutes.map((item) => ({
        label: item.brandName,
        id: item.id,
        ...item,
      }));
      setInstituteList(formattedData);
      setStarterPhrase(""); // Clear starter phrase on successful fetch
    }
  } catch (error) {
    console.error("Error fetching institute info:", error);
  }}

      
      useEffect((id)=>{
        
        setIsLoading(true)
        setinstituteDetails([]);
        setOvdCount([]);
        setOvdPercentage([]);
        setOvdPOS([]);
        setMonths([]);
        setDisbursementAmounts([]);
        setActualDisbursementAmounts([]);
        setApplMonth([]);
        setApplDisb([]);
        setApplCount([]);
        setApplRate([]);

        const instId = id ? id : "";
        let queryParams = {}
        
        if(id){
          queryParams.instituteId = id
        }
      
        if(decode?.channelPartnerId){
          queryParams.channelId = decode?.channelPartnerId
        }
        let dashboardQueryParams = { ...queryParams };
        if (productTypeSelected && productTypeSelected !== "all") {
          dashboardQueryParams.loanType = Number(productTypeSelected);
        }
        if (productTypeSelected && productTypeSelected !== "all") {
          queryParams.productType = Number(productTypeSelected);
        }
        // const queryParams = new URLSearchParams({ instituteId: instId,channelId: decode?.channelPartnerId}).toString();
        const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-indexed
        const day = today.getDate().toString().padStart(2, '0'); // Ensure day is 2 digits
        return `${year}-${month}-${day}`;
      };
          const endDate = getCurrentDate();
        let response2QueryParams = {}
        if(id){
          response2QueryParams.instituteId = id
        }
      
        if(decode?.channelPartnerId){
          response2QueryParams.channelId = decode?.channelPartnerId
        }
        if(endDate){
          response2QueryParams.endDate = endDate
        }
        
        if (productTypeSelected && productTypeSelected !== "all") {
          response2QueryParams.loanType = Number(productTypeSelected);
        }


      
        const urlGetInstituteInfo=`/analytics/institute-dashboard`
        const response1 = `/analytics/month-disburements`
    
        const response2=`/analytics/get-institute-ovd`
        const response3 = `/analytics/get-application`
        setTopCardsLoading(true);
        {
          axiosInstance.get(urlGetInstituteInfo, {
            params: dashboardQueryParams,
            headers:{
            }
          }).then((res) => {
            setinstituteDetails(res?.data?.dashboard?.instituteDetails?.instituteDetails)
              setTopCardsLoading(false);
            // const loadingTimeout = setTimeout(() => {
            //   setIsLoading(false);
            // }, 300);
            
          });}


          {
            axiosInstance.get(response1,{params:queryParams,
              headers:{
              }
            }).then((res) => {
              const lastSixMonths = res?.data?.data?.monthwise.slice(-12);
              const monthLable=lastSixMonths.map((item) => item.month);
              setMonths(lastSixMonths.map((item) => item.month))
             const disbursementAmounts = lastSixMonths.map((item) => Math.round(item.disbursement_amount));
             const count=lastSixMonths.map((item) => Math.round(item.ApplicationCount));
             setDisbursementAmounts(lastSixMonths.map((item) => Math.round(item.disbursement_amount)))
             setActualDisbursementAmounts(lastSixMonths.map((item) => Math.round(item.Disbursedamount)))  
              setTotalSales(disbursementAmounts.reduce((a, b) => a + b, 0));
              setTotalAppCount(count.reduce((a, b) => a + b, 0))
              setThisMonthSales(disbursementAmounts[disbursementAmounts.length - 1]); 
              setThisMonthCount(count[count.length - 1])
              setThisWeekSales(lastSixMonths[lastSixMonths.length - 1]);
              // const loadingTimeout = setTimeout(() => {
              //   setIsLoading(false);
              // }, 300);

              
            });}

            {
              axiosInstance.get(response3,{params:queryParams,
                headers:{
                }
              }).then((res) => {
                const lastSixMonths = res?.data?.data?.application?.application.slice(-12);
               setApplMonth(lastSixMonths.map((item) => item.month))
               setApplDisb(lastSixMonths.map((item) => Math.round(item.disbursed_applications)))
               setApplCount(lastSixMonths.map((item) => Math.round(item.total_applications)))
               setApplRate(lastSixMonths.map((item) => Math.round(item.Approval_Rate)))
                // const loadingTimeout = setTimeout(() => {
                //   setIsLoading(false);
                // }, 300);

              });}

              {
                axiosInstance.get(response2,{params:response2QueryParams,
                  headers:{
                  }
                }).then((res) => {
                  setOvdBackets(res?.data?.data?.OvdInstitute?.institutewisebuckets.map((item)=>item.bucketings))
                  setOvdPercentage(res?.data?.data?.OvdInstitute?.institutewisebuckets.map((item)=>item.backets_sum_amount))
                  setOvdCount(res?.data?.data?.OvdInstitute?.institutewisebuckets.map((item)=>item.bucket_count))
                  setOvdPOS(res?.data?.data?.OvdInstitute?.institutewisebuckets.map((item)=>item.sumOf_principle_amount))

                  // const loadingTimeout = setTimeout(() => {
                  //   setIsLoading(false);
                  // }, 300);
  
                });}

        setTimeout(() => {
          setIsLoading(false);
        }, 800);
    

      }, [productTypeSelected])

      const instituteInfo=()=>{ 
        setIsLoading(true)

        setSearchClicked(!searchClicked);
        let queryParams = {};

        if (id) {
          queryParams.instituteId = id
        }

        if (productTypeSelected && productTypeSelected !== "all") {
          queryParams.loanType = Number(productTypeSelected);
        }
            const urlGetInstituteInfo=`/analytics/institute-dashboard`
            {
              axiosInstance.get(urlGetInstituteInfo,{
                params: queryParams,
                headers:{
                }
              }).then((res) => {
                setinstituteDetails(res?.data?.dashboard?.instituteDetails?.instituteDetails)
                // const loadingTimeout = setTimeout(() => {
                //   setIsLoading(false);
                // }, 300);
              });}


      }




      const instiDisbursement=(id)=>{
        setIsLoading(true)
        let queryParams = {};


        if (productTypeSelected && productTypeSelected !== "all") {
          queryParams.productType = Number(productTypeSelected);
        }
    
        const response1 = `/analytics/month-disburements?instituteId=${id}`

        {
          axiosInstance.get(response1,{
            params: queryParams,
            headers:{
            }
          }).then((res) => {
              const lastSixMonths = res?.data?.data?.monthwise.slice(-12);
              const monthLable=lastSixMonths.map((item) => item.month);
              setMonths(lastSixMonths.map((item) => item.month))
             const disbursementAmounts = lastSixMonths.map((item) => Math.round(item.disbursement_amount));
             setDisbursementAmounts(lastSixMonths.map((item) => Math.round(item.disbursement_amount)))
             setActualDisbursementAmounts(lastSixMonths.map((item) => Math.round(item.Disbursedamount))) 
             const count=lastSixMonths.map((item) => Math.round(item.ApplicationCount));
             setTotalAppCount(count.reduce((a, b) => a + b, 0))
              setTotalSales(disbursementAmounts.reduce((a, b) => a + b, 0));
              setThisMonthSales(disbursementAmounts[disbursementAmounts.length - 1]); 
              setThisWeekSales(lastSixMonths[lastSixMonths.length - 1]);
              setThisMonthCount(count[count.length - 1])
              // const loadingTimeout = setTimeout(() => {
              //   setIsLoading(false);
              // }, 300);
            
          });}


      }


     const instiBackets=(id)=>{

      setIsLoading(true)
      const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-indexed
        const day = today.getDate().toString().padStart(2, '0'); // Ensure day is 2 digits
        return `${year}-${month}-${day}`;
      };
      const endDate = getCurrentDate();
       let queryParams = {};

      

       if (productTypeSelected && productTypeSelected !== "all") {
         queryParams.loanType = Number(productTypeSelected);
       }
         const response2=`/analytics/get-institute-ovd?endDate=${endDate}&instituteId=${id}`
      {
        axiosInstance.get(response2,{
          params: queryParams,
          headers:{
          }
        }).then((res) => {
          setOvdBackets(res?.data?.data?.OvdInstitute?.institutewisebuckets.map((item)=>item.bucketings))
          setOvdPercentage(res?.data?.data?.OvdInstitute?.institutewisebuckets.map((item)=>item.backets_sum_amount))
          setOvdCount(res?.data?.data?.OvdInstitute?.institutewisebuckets.map((item)=>item.bucket_count))
          setOvdPOS(res?.data?.data?.OvdInstitute?.institutewisebuckets.map((item)=>item.sumOf_principle_amount))
          // const loadingTimeout = setTimeout(() => {
          //   setIsLoading(false);
          // }, 300);

        });}
     }

  const applicationVisist=(id)=>{
    setIsLoading(true)
    let queryParams = {};



    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.productType = Number(productTypeSelected);
    }
      const response3 = `/analytics/get-application?instituteId=${id}`
    axiosInstance.get(response3,{
      params: queryParams,
      headers:{
      }
    }).then((res) => {
      const lastSixMonths = res?.data?.data?.application?.application.slice(-12);
     setApplMonth(lastSixMonths.map((item) => item.month))
     setApplDisb(lastSixMonths.map((item) => Math.round(item.disbursed_applications)))
     setApplCount(lastSixMonths.map((item) => Math.round(item.total_applications)))
      setIsLoading(false);

    });
  

  }
  const clearDateFilter = () => {
    window.location.reload()}

    const handleButtonClick = () => {
      if (!internalValue.trim()) {
        window.location.reload();
      } else {
        const selectedId = id || "";
        instituteInfo(selectedId);
        instiDisbursement(selectedId);
        instiBackets(selectedId);
        applicationVisist(selectedId);
      }
    };

    
  return (
    <div style={{width:"100%",backgroundColor:'#f9fafa',minHeight:'100vh'}}>
       <div style={{display:'flex',justifyContent:'space-between'}}>
       <h1 style={{fontFamily:'Inter-Medium',fontSize:'25px',fontWeight:'500',padding:'10px',color:'#101828'}}>{internalValue?internalValue:'All Merchants '} Dashboard</h1>
       </div>
    <>
      {/* <BreadCrumbs /> */}

      <div  style={{display:'flex'}}>
      <div style={{ position: "relative",  marginTop:'8px'}}>
     <Autocomplete
      freeSolo={false}
      noOptionsText={startingPhrase}
      disablePortal
      size="small"
      value={internalValue}
      options={ instituteList.map((item) => item.brandName) }
      onInputChange={(event, newInputValue, reason) => {
        if (reason === 'clear') {
          window.location.reload(); // ⬅ reload page when clear button is clicked
          return;
        }
       if (reason === "input") {
                getInstituteInfo(newInputValue);

                const matchedItem = instituteList.find(
                  (item) =>
                    item.brandName.toLowerCase().trim() === newInputValue.toLowerCase().trim()
                );

                if (matchedItem) {
                  setId(matchedItem.id);
                  setInternalValue(matchedItem.brandName);
                } else {
                  setId('');
                  setInternalValue(""); 
                }
              }                                    
                  }
             }
      onChange={(event, selectedValue) => {
        const selectedItem = instituteList.find((item) => item.brandName === selectedValue);
        if (selectedItem) {
          setId(selectedItem.id)
          setInternalValue(selectedItem.brandName); 
          setIsInstituteSelected(true);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? 'Product Type':"Institute Name"}
          placeholder='Atleast 4 Characters'
          noOptionsText='No options'
         
          InputLabelProps={{
            sx: {
              fontFamily: "Outfit",
              bgcolor: "#fff8f4",
              fontWeight: "bold",
              borderRadius: "5px",
              fontSize: "16px",
              lineHeight: "20.25px",
              padding: "2px 8px",
              color: "#000",
              marginLeft: '30px',
            },
          }}
          sx={{
            minWidth: 300,
            mb: 2,
            "& label.Mui-focused": {
              color: "#000",
            },
            "& .MuiOutlinedInput-root": {
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '10px center',
              backgroundSize: '20px 20px',
              paddingLeft: '40px',
              paddingRight:'60px',
              marginLeft: '10px',
              "& fieldset": {
                borderColor: "#707C8B",
              },
              "&:hover fieldset": {
                borderColor: "#707C8B",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#707C8B",
              },
              "& input": {
                marginRight: '50px', // 👈 this is the correct selector for the text input
                fontFamily: 'Outfit',
              },
            },
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <img src={search} alt="Search" style={{ width: "20px", height: "20px" }} />
              </InputAdornment>
            ),
          }}
       
        />
      )}
    /></div>
            <div>
            {/* {searchClicked === true ? (
        <button style={{backgroundColor:'#D22129',display:'flex',alignItems:'center',width:'130px',height:'34px',justifyContent:'space-around',borderRadius:'5px',cursor:'pointer',paddingLeft:'10px',marginTop:'10px'}} onClick={clearDateFilter}>
                  <img src={clear} style={{height:'18px'}}/>
                  <div style={{color:'white',display:'flex',alignItems:'center'}}>Clear Filter</div>
                </button>
      ):( */}
        <button style={{backgroundColor:'#D22129',display:'flex',alignItems:'center',width:'130px',height:'34px',justifyContent:'space-around',borderRadius:'5px',cursor:'pointer',paddingLeft:'10px',marginTop:'10px',color:'white',marginLeft:'40px'}}
            
            onClick={handleButtonClick}
            >
              Search Results
            </button>
            {/* )} */}
            </div>

            </div>

            {isLoading ? (
                  <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
                  <CircularProgress />
                </Box>
                ): ( 
                 
                <>
                {topCardsLoading ? (
                  <div style={{
                    display: "flex",
                    gap: "20px",
                    padding: "10px"
                  }}>

                    {[1, 2, 3, 4].map((item) => (
                      <div
                        key={item}
                        style={{
                          height: "80px",
                          flex: 1,
                          borderRadius: "10px",
                          // backgroundColor: "#e5e7eb"
                          background: "linear-gradient(110deg, #f1f5f9 8%, #ffffff 18%, #f1f5f9 33%)",
                          backgroundSize: "200% 100%",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                          border: "1px solid #e5e7eb",
                          animation: "shimmer 1.5s linear infinite",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      />
                    ))}
                    <style>
                      {`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}
                    </style>
                  </div>
                ) : (
                <TopCards instituteDetails={instituteDetails} ovdCount={ovdCount} ovdPercentage={ovdPercentage}  ovdPos={ovdPos}  />)}<Row style={{ marginTop: '20px' }}>
                <Col lg="8">
                  <SalesOverview totalSales={totalSales} thisMonthSales={thisMonthSales} thisWeekSales={thisWeekSales} months={months} disbursementAmounts={disbursementAmounts} thisMonthCount={thisMonthCount} totalAppCount={totalAppCount} actualDisbursementAmounts={actualDisbursementAmounts}/>
                </Col>
                {/* <Col lg="3">
                  <Blog2 />
                  </Col> */}
                <Col lg="4">
                  <VisitSeparation ovdBackets={ovdBackets} ovdCount={ovdCount} ovdPercentage={ovdPercentage} />
                </Col>

              
              </Row>
              
                 <Row>
                  <Col lg="4">
                    <Gmail instituteDetails={instituteDetails}  />          
                    <Facebook instituteDetails={instituteDetails}  />
                    <Twitter instituteDetails={instituteDetails} />
                  </Col>
                  <Col lg="8">
                    <WebsiteVisit applCount={applCount}   applmonth={applmonth}  applDisb={applDisb} applRate={applRate} />
                  </Col>
                </Row>
              
              
              
              </>)}
    
      {/* <Row>
        <Col lg="4">
          <Gmail />          
          <Facebook />
          <Twitter />
        </Col>
        <Col lg="8">
          <WebsiteVisit />
        </Col>
      </Row>
      <Row>
        <Col lg="6">
          <ProjectMonth />
        </Col>
        <Col lg="6">
          <Activity />
        </Col>
      </Row>
      <Row>
        <Col lg="6">
          <RecentComments />
        </Col>
        <Col lg="6">
          <RecentChat />
        </Col>
      </Row> */}
    </>

    </div>
  );
};

export default Demographical;
